import { getAnalytics, logEvent } from "firebase/analytics";
import { firebaseApp } from "../store/LoggerContext";

// Events for the Free-on-YouTube landing page (#588 instrumentation, #590
// arrival). They go to Firebase Analytics, not the API log endpoint: the
// page's main audience is logged-out prospects, and the API log endpoint
// only accepts signed-in requests, so their events would be dropped there.
//
// Embed play is not recorded yet: that needs the YouTube IFrame Player API
// script, which this first version does not load.

export type YouTubeLandingEvent =
  | "youtube_landing_view"
  | "youtube_watch_on_youtube"
  | "youtube_join_click"
  | "youtube_get_app_click";

export const logYouTubeLandingEvent = (
  event: YouTubeLandingEvent,
  params: { [key: string]: string | number | undefined },
): void => {
  try {
    logEvent(getAnalytics(firebaseApp), event, params);
  } catch (e) {
    // Analytics blocked or unavailable (ad blocker, private window): the page
    // must still work, so log locally and carry on.
    console.error(`[YouTubeLanding] analytics event ${event} failed`, e);
  }
};
